module.exports = __webpack_public_path__ + "img/adm2.95cbbc6d.png";